module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou16-7175b1cda1cf46531eb68ab19026cdb7.jpg";